import { BugReportModalBase } from "./BugReportModalBase";

import { useBugReporter } from "utils/hooks/use-bug-reporter";

export const BugReportModalWithNoAv = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => <BugReportModalBase open={open} useBugReporter={useBugReporter} onClose={onClose} />;
